import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideShare2 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <circle cx={18} cy={5} r={3} />
      <circle cx={6} cy={12} r={3} />
      <circle cx={18} cy={19} r={3} />
      <path d="m8.59 13.51 6.83 3.98m-.01-10.98-6.82 3.98" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideShare2);
const Memo = memo(ForwardRef);
export default Memo;
